import * as React from "react";
import { useState, useEffect } from "react";
import { AMLCheckClient } from "../../../../../../Wrap/Api/Customer/AMLCheck";
import { AMLCheckACtion } from "../Action/AMLCheckAction";

interface IAMLCheckProps {
    customerId: number;
    onSuccess: () => void;
}

export const AMLCheck = (props: IAMLCheckProps) => {
    const [isRequested, setisRequested] = useState(false);
    const [isSuccess, setIsSuccess] = useState(null);
    return (
        <div className="col-auto">
            <button
                disabled={isRequested}
                className="btn primary"
                onClick={() => {
                    setisRequested(true);
                    AMLCheckACtion.getAmlCheck(props.customerId, (res) => {
                        if (res !== "An error occured") {
                            props.onSuccess();
                        } else {
                            setIsSuccess(false);
                        }
                    });
                }}
            >
                {!isRequested ? "Request Check" : isSuccess == false ? "Check failed" : "Check in progress"}
            </button>
        </div>
    );
};
